import { EXPLORE_PRESET } from '@src/models/presets';

export const getDimensionListFromPreset = (newPreset) => {
  const dimensions = newPreset.presetDimensions[EXPLORE_PRESET].currentDimensions;
  const a: string[] = [];
  Object.keys(dimensions).forEach((dimensionName) => {
    const index = dimensions[dimensionName].sort;
    a[index] = dimensionName;
  });
  return a;
};
